import React, { useState, useEffect } from "react";

import logo from "./assets/codeux-logo.svg";
import bg from "./assets/lines.svg";
import cross from "./assets/Cross.svg";
import code from "./assets/Code.svg";
import circle from "./assets/Circle.svg";

import "./App.css";

import Typist from "react-typist";

const styles = {
  root: {
    backgroundColor: "#161616",
    height: "100vh",
    overflow: "hidden",
  },
  bg: {
    backgroundImage: `url(${bg})`,
    height: "100vh",
    width: "100vw",
    transform: "scale(1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    position: "absolute",
    top: "10%",
    left: "10%",
    zIndex: 10,
  },
  logo: {
    pointerEvents: "none",
  },
  codeContainer: {
    position: "absolute",
    top: "calc(-6vw + 10%)",
    right: "18vw",
  },
  code: {
    maxWidth: 273,
    maxHeight: 447,
    width: "13.65vw",
    minWidth: 150,
    minHeight: "auto",
  },
  crossContainer: {
    position: "absolute",
    bottom: "10vw",
    left: "-10%",
  },
  cross: {
    maxHeight: 350,
    maxWidth: 350,
    minHeight: 200,
    minWidth: 200,
    height: "17.5vw",
    width: "17.5vw",
  },
  circleContainer: {
    position: "absolute",
    bottom: "25%",
    right: "-5%",
  },
  circle: {
    maxHeight: 350,
    maxWidth: 350,
    minHeight: 200,
    minWidth: 200,
    height: "11vw",
    width: "11vw",
  },
  textContainer: {
    position: "absolute",
    top: "30%",
    left: "15%",
  },
  text: {
    color: "#FFF",
    fontWeight: "300",
    fontSize: 100,
    fontFamily: "'Inter', sans-serif",
    fontSize: "5vw",
  },

  span: {
    color: "#FFF",
    fontSize: "5vw",
    fontWeight: "800",
    fontFamily: "'Inter', sans-serif",
  },
  textComingSoonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    bottom: "10%",
    width: "80%",
  },
  textComingSoon: {
    color: "#FFF",
    fontWeight: "200",
    fontSize: 24,
    textAlign: "center",
    fontFamily: "'Inter', sans-serif",
  },
  comingSoon: {
    marginTop: 20,
    width: 145,
    height: 60,
    cursor: "pointer",
  },
};

function App() {
  const [count, setCount] = useState(1);

  useEffect(() => {
    window.location.replace("https://www.codeux.tech");
  }, []);

  useEffect(() => {
    setCount(1);
  }, [count]);

  return (
    <div style={styles.root}>
      <div style={styles.bg}>
        <div style={styles.header}>
          <img src={logo} style={styles.logo} alt="logo" />
        </div>
        <div style={styles.codeContainer} className="App-code">
          <img src={code} style={styles.code} alt="code" />
        </div>
        <div style={styles.crossContainer} className="App-cross">
          <img src={cross} style={styles.cross} alt="logo" />
        </div>
        <div style={styles.circleContainer} className="App-circle">
          <img src={circle} style={styles.circle} alt="logo" />
        </div>
        <div className="textContainer" style={styles.textContainer}>
          <text classname="text" style={styles.text}>
            We build <br></br> products that
          </text>
          <div className="type">
            {count && (
              <Typist avgTypingDelay={30} onTypingDone={() => setCount(0)}>
                <span style={styles.span}> AMAZE</span>
                <Typist.Backspace count={5} delay={800} />
                <span style={styles.span}> YOU'LL LOVE</span>
                <Typist.Backspace count={11} delay={800} />
                <span style={styles.span}> ARE COOL 😎</span>
                <Typist.Backspace count={12} delay={800} />
                <span style={styles.span}> BLOW MINDS 🤯</span>
                <Typist.Backspace count={13} delay={800} />
                <span style={styles.span}> ARE EFFICIENT</span>
                <Typist.Backspace count={13} delay={800} />
                <span style={styles.span}> ARE ROBUST</span>
                <Typist.Backspace count={10} delay={800} />
              </Typist>
            )}
          </div>
        </div>
        <div style={styles.textComingSoonContainer}>
          <text style={styles.textComingSoon}>
            We are going through a makeover right now. Be right back!
          </text>
        </div>
      </div>
    </div>
  );
}

export default App;
